import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
require("@/assets/css/style.css");
require("@/assets/css/simple-sidebar.css");

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

router.afterEach(() => {
  // Código de Google Tag Manager
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-N4R6P2LD"); // Reemplaza 'GTM-XXXXXXXXX' con tu ID de contenedor de Google Tag Manager
});

new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js